import { createSlice, } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { outstandingPayable } = stateEnum

const initialState = {  
  currentParty: {
    id:"",
    name:"",
    remaningDaysRange:"",
  },
  isFromDashboard:false
}
  
const outstandingPayableSlice = createSlice({
  name: `${outstandingPayable}`,
  initialState,
  reducers: {  
    setCurrentParty: (state, action) => {
      state.currentParty.name = action.payload.party
      state.currentParty.id = action.payload.party_id

    },
    setCurrentPartyDaysRange: (state, action) => {
      state.currentParty.remaningDaysRange = action.payload.daysRange
    },
    setIsFromDashboardPayable: (state, action) => {
      state.isFromDashboard=action.payload;
    },
  }, 
})

export const { 
  setCurrentParty,
  setCurrentPartyDaysRange,
  setIsFromDashboardPayable
} = outstandingPayableSlice.actions
export default outstandingPayableSlice.reducer
